module.exports = __webpack_public_path__ + "img/symbol_2.a4845594.png";